<template>
	<div class="main-content" v-loading="loading">
		<div class="order-view" v-if="!loading">
			<div class="form-group">
				<div class="form-left">
					<div style="float: left;">
						<div>订单号：{{dataInfo.order_no}}</div>
						<div class="box-con-btn" style="padding: 10px 0;"><span class="text-red">修改订单</span></div>
					</div>
					<div style="display: table;padding-left: 20px;">
						<div style="display: table-cell;width: 100px;text-align: right;">审核备注： </div>
						<div >{{dataInfo.audit_remark?dataInfo.audit_remark:'无'}}</div>
					</div>
				</div>

				<div>
					<div class="step-progress" style="margin-left: 20px;">
						<div class="step-slider step-active">总部审核<span class="iconfont iconchangjiantou-you"></span></div>
						<block v-if="dataInfo.status=='21'">
						<div class="step-slider step-active">审核不通过<span class="iconfont iconchangjiantou-you"></span></div>
						<div class="step-slider step-active">修改订单<span class="iconfont iconchangjiantou-you"></span></div>
						<div class="step-slider">总部审核<span class="iconfont iconchangjiantou-you"></span></div>
						</block>
						<div class="step-slider">经销商付款<span class="iconfont iconchangjiantou-you"></span></div>
						<div class="step-slider">总部发货<span class="iconfont iconchangjiantou-you"></span></div>
						<div class="step-slider">经销商签收<span class="iconfont iconchangjiantou-you"></span></div>
						<div class="step-slider">订单完成</div>
					</div>

				</div>
			</div>
			<div class="mt50">
				<div class="box-con-tit">
					<div class="mb10"><span>要货日期：{{demand_date}}</span> </div>
					<div v-if="!is_modify_address"><span>收货地址：{{dataInfo.consignee_address}}</span>
						<span class="ml50">联系人：{{dataInfo.consignee_name}}</span>
						<span class="ml50">联系电话：{{dataInfo.consignee_mobile}}</span><button class="ml50 bnt-buy" @click="openAddress()" style="background: rgb(89, 109, 230);">
							修改地址
						</button> </div>
					<div v-else><span>收货地址：<span class="bottom-line">{{address.address}}</span></span>
						<span class="ml50">联系人：<span class="bottom-line">{{address.name}}</span></span>
						<span class="ml50">联系电话：<span class="bottom-line">{{address.tel}}</span></span> <button class="ml50 bnt-buy" @click="openAddress()" style="background: rgb(89, 109, 230);">
							修改地址
						</button></div>
					<div>备注：<el-input placeholder="请输入备注" v-model='remark' class='remark-input' style="width: 400px;"></el-input>
					</div>
				</div>
			</div>
			<div class="mt50">
				<div class="order-table table-heard" style="margin-bottom: 0;">
					<div class="order-th">操作</div>
					<div class="order-th" style="flex: 2;">商品名称</div>
					<div class="order-th">规格型号</div>
					<div class="order-th">助记码</div>
					<div class="order-th">条形码</div>
					<div class="order-th">订货数量</div>
					<div class="order-th">计量单位</div>
					<div class="order-th">件数</div>
					<div class="order-th">单价</div>
					<div class="order-th">金额</div>
				</div>

				<div class="order-item">
					<div class="order-table" v-for="(sku,index) in dataInfo.skus">
						<div class="order-th"><span class="delete-goods" @click="deleteItem(index)">删除</span> </div>
						<div class="order-th" style="flex: 2;">{{sku.name}}</div>
						<div class="order-th">{{sku.sku_name}}</div>
						<div class="order-th">{{sku.mnemonic_code}}</div>
						<div class="order-th">{{sku.barcode}}</div>
						<div class="order-th">
							<el-input placeholder="请输入数量" @change='changeQty(index)' v-model="sku.sale_price_unit_qty"></el-input>
						</div>
						<div class="order-th">{{sku.sale_price_unit}}</div>
						<div class="order-th">
							<el-input placeholder="请输入数量" @change='changeNuitQty(index)' v-model="sku.sale_unit_qty"></el-input>
						</div>
						<div class="order-th">{{sku.price}}</div>
						<div class="order-th">{{sku.subtotal_price}}</div>
					</div>
				</div>

			</div>
			<div class="mt50">
				<div class="box-con-tit tr">
					<span class="mr20">总件数：{{dataInfo.sale_unit_qty}}</span><span class="mr20">总数量：{{dataInfo.sale_price_unit_qty}}</span>
					<span class="mr20">总金额：{{dataInfo.total_price}}</span>
					<button class="bnt-buy" style="background: red;" @click="submit">提交订单</button>
				</div>
			</div>
		</div>
		<div v-if="mask"><Address @selectFunc="selectFunc" :selectValue="address"></Address></div>
	</div>
</template>

<script>
	import Address from '@/components/address'
	export default {
		name: 'order-view',
		data() {
			return {
				id: '',
				loading: true,
				dataInfo: {},
				remark: '',
				demand_date: '',
				is_modify_address: false,
				address:{},
				mask: false,
			}
		},
		created: function() {
			this.id = this.$route.query.id;
			this.reload();
			//this.address = this.$store.state.address;
			//this.is_modify_address = this.$store.state.is_modify_address;
			this.$store.dispatch('modifyAddressFun', false)
			this.GetDateStr();
		},
		components: {
			Address: Address
		},
		methods: {
			openAddress: function() {
				this.mask = true;
			},
			selectFunc: function(e) {
				this.address = e;
				this.mask = false;
				this.is_modify_address = true;
			},
			GetDateStr: function() {
				var dd = new Date();
				dd.setDate(dd.getDate() + 6); //获取AddDayCount天后的日期 
				var y = dd.getFullYear();
				var m = dd.getMonth() + 1; //获取当前月份的日期 
				var d = dd.getDate();
				this.demand_date = y + "-" + m + "-" + d;
			},
			reload: function() {
				var params = {
					id: this.id
				}
				this.https.fetchGet('/pc/service/trade/order/details', params)
					.then((res) => {
						if (res.data.success) {
							var data = res.data.content;
							this.dataInfo = data;
							this.loading = false;
							this.remark = data.user_remark;
						}

					}).catch(err => {
						console.log(err)
					})
			},
			//数量加减
			changeQty: function(index) {
				var skus = this.dataInfo.skus;
				var sale_price_unit_qty = skus[index].sale_price_unit_qty;
				if (sale_price_unit_qty < 1 || sale_price_unit_qty == '') {
					sale_price_unit_qty = 1;
				}
				sale_price_unit_qty = parseInt(sale_price_unit_qty);
				var sale_unit_qty = (sale_price_unit_qty / skus[index].convert_numerator).toFixed(2);
				skus[index].sale_unit_qty = sale_unit_qty;
				skus[index].sale_price_unit_qty = sale_price_unit_qty;
				this.dataInfo.skus = skus;
				var params = {
					sku_id: this.dataInfo.skus[index].id,
					sale_unit_qty: sale_unit_qty,
					sale_price_unit_qty: sale_price_unit_qty,
				}
				this.updataItem(params);
			},
			changeNuitQty: function(index) {
				var skus = this.dataInfo.skus;
				var sale_unit_qty = skus[index].sale_unit_qty;
				var sale_price_unit_qty = 0;
				if (sale_unit_qty > 0) {
					sale_price_unit_qty = parseInt(sale_unit_qty * skus[index].convert_numerator);
				} else {
					sale_unit_qty = 0;
				}
				skus[index].sale_unit_qty = sale_unit_qty;
				skus[index].sale_price_unit_qty = sale_price_unit_qty;
				this.dataInfo.skus = skus;
				var params = {
					sku_id: this.dataInfo.skus[index].id,
					sale_unit_qty: sale_unit_qty,
					sale_price_unit_qty: sale_price_unit_qty,
				}
				this.updataItem(params);
			},
			updataItem: function(params) {
				this.https.fetchPost('/pc/service/trade/order/update-item', params).then((res) => {
					if (res.data.success) {
						this.$message({
							type: 'success',
							message: '修改成功'
						});
						this.reload();
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//删除商品
			deleteItem: function(index) {
				var params = {
					sku_id: this.dataInfo.skus[index].id
				}
				this.$confirm('是否要删除该商品', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.https.fetchPost('/pc/service/trade/order/delete-item', params)
						.then((res) => {
							if (res.data.success) {
								this.reload();
							}

						}).catch(err => {
							console.log(err)
						})
				}).catch(err => {
					console.log(err)
				})
			},
			//提交订单
			submit: function() {
				if (this.is_modify_address) {
					var params = {
						consignee_name: this.address.name,
						consignee_mobile: this.address.tel,
						consignee_address: this.address.address,
						demand_date: this.demand_date,
						remark: this.remark,
						order_id: this.id,
						status:this.dataInfo.status,
						consignee_address_no:this.address.address_no,
						status:'10',
					}
				} else {
					var params = {
						consignee_name: this.dataInfo.consignee_name,
						consignee_mobile: this.dataInfo.consignee_mobile,
						consignee_address: this.dataInfo.consignee_address,
						demand_date: this.demand_date,
						remark: this.remark,
						order_id: this.id,
						status:'10',
						consignee_address_no:this.dataInfo.consignee_address_no
					}
				}
				this.https.fetchPost('/pc/service/trade/order/update', params)
					.then((res) => {
						if (res.data.success) {
							this.$message({
								type: 'success',
								message: '修改成功'
							});
							this.$router.push({
								name: 'orderlist',
							})
						}

					}).catch(err => {
						console.log(err)
					})
			}
		}
	};
</script>

<style scoped="">
	.mt50 {
		margin-top: 50px;
	}

	.ml50 {
		margin-left: 50px;
	}

	.mr20 {
		margin-right: 20px;
	}

	.mb10 {
		margin-bottom: 10px;
	}

	.tr {
		text-align: right;
	}

	.order-view {
		padding: 20px;
	}

	.form-group {
		padding: 20px;
		display: flex;
		align-items: center;
		background: #fff;
	}

	.form-left {
		padding-right: 50px;
		border-right: 2px solid #F0F0F0;
		    width: 50%;
	}

	.box-con-btn {
		padding: 10px 0;
	}

	.text-red {
		color: red;
	}

	.btn-default {
		background: rgb(84, 142, 230);
		color: #fff;
		border: 0;
		padding: 10px 20px;
		cursor: pointer;
		border-radius: 5px;
		margin-left: 20px;
	}

	.box-con-tit {
		background: #fff;
		padding: 20px;
	}

	.sign-confirm {
		background: red;
		color: #fff;
		border: 0;
		border-radius: 5px;
		padding: 10px 20px;
		cursor: pointer;
		margin-bottom: 10px;
	}

	.remark-input {
		display: inline-block;
		width: 400px;
		margin-top: 10px;
	}

	.delete-goods {
		cursor: pointer;
		color: rgba(59, 82, 215, 1);
	}

	.bnt-buy {
		background: rgb(74, 144, 138);
		color: #fff;
		border: 0;
		padding: 10px 30px;
		cursor: pointer;
		border-radius: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/views/order-modify.vue